<template>

    <div class="makes">
        <h1>{{ msg }}</h1>
    </div>

</template>


<script>

    // eslint-disable-next-line
    import router from '../router';

    // eslint-disable-next-line
    import store from '../store';

    export default {

        name: 'Makes',

        data() {
            return {
                msg: 'Stupendo.us Makes ' + this.$route.params.slug + '!'
            }
        },

        created() {

        },

        computed: {

        }

    }

</script>


<style lang="scss" scoped>

    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

</style>
